// GENERATE BY ./scripts/generate.ts
// DO NOT EDIT IT MANUALLY
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import MinusCircleFilledSvg from '../../vendors/asn/MinusCircleFilled';
import AntdIcon from '../components/AntdIcon';
var MinusCircleFilled = function (props, ref) { return React.createElement(AntdIcon, __assign({}, props, { ref: ref, icon: MinusCircleFilledSvg })); };
MinusCircleFilled.displayName = 'MinusCircleFilled';
/*
 *  temporary disable this rule for build
 */
// @ts-ignore
export default React.forwardRef(MinusCircleFilled);
